import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CurrentUser = ({ jwtToken }) => {
    const [currentUser, setCurrentUser] = useState([]);

    useEffect(() => {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);
        const requestOptions = {
            method: "GET",
            headers: headers,
        };
        fetch(`${process.env.REACT_APP_BACKEND}/api/profile`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setCurrentUser(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    return (
        <div>
            {currentUser && (
                <>
                    <div>{currentUser.name}</div>
                    <div>{currentUser.balanceFormatted}</div>
                </>
            )}
        </div>
    );
};

export default CurrentUser;
